import { prefetchPermission } from './common/providers/user-permission-provider';
import { prefetchAvailableProducts } from './common/providers/products-data-provider';
import { prefetchJoinableSites } from './cross-join/providers/joinable-sites-data-provider';
import prefetchSwitcherBundles from './common/utils/prefetch-bundles';
import { prefetchFlightDeck } from './common/providers/flight-deck-provider';
import { prefetchThirdPartyProducts } from './common/providers/third-party-products-data-provider';
export var prefetchAll = function prefetchAll(props) {
  var cloudId = props.cloudId,
    product = props.product;
  prefetchSwitcherBundles(product);
  prefetchFlightDeck({});
  prefetchAvailableProducts({
    cloudId: cloudId,
    product: product
  });
  prefetchThirdPartyProducts({
    cloudId: cloudId,
    product: product
  });
  prefetchJoinableSites(props.joinableSitesDataProvider);
  if (cloudId) {
    prefetchPermission({
      cloudId: cloudId
    });
  }
};